<template>
  <div
    v-if="recommendedProducts"
    class="cross-selling-product-teasers-fi"
  >
    <product-teasers-fi
      :custom-fields="{
        headline: { value: $dict.get('online-Shop.Product-Teaser.Cross-Selling.Headline') },
        productList: { value: recommendedProducts },
        hideContent: { value: true },
      }"
      :light="light"
      is-recommendation
      @product-added="$emit('product-added', $event)"
    />
  </div>

  <section-divider-small-fi v-else />
</template>

<script setup lang="ts">
import { useQuery } from '@urql/vue';
import { computed, defineAsyncComponent, ref, watch } from 'vue';

import type { AddProductData } from '@/components/product-tile-fi/ProductTileFi.vue';
import { useFischer } from '@/composables/fischerPlugin';
import type {
  GetRecommendationsQuery,
  GetRecommendationsQueryVariables,
} from '@/generated/graphql';
import GET_RECOMMENDATIONS from '@/graphql/getRecommendations.gql';

defineOptions({ name: 'CrossSellingProductTeasersFi' });

const ProductTeasersFi = defineAsyncComponent(
  () => import('@/pages/product-teasers-fi/ProductTeasersFi.vue'),
);

const SectionDividerSmallFi = defineAsyncComponent(
  () => import('@/pages/section-divider-fi/SectionDividerSmallFi.vue'),
);

const props = withDefaults(
  defineProps<{
    productIds: string;
    light?: boolean;
  }>(),
  {
    light: false,
  },
);

defineEmits<{
  (e: 'product-added', payload: AddProductData): void;
}>();

const fischer = useFischer();

const recommendedProducts = ref<string | null>(null);

const { data } = useQuery<GetRecommendationsQuery, GetRecommendationsQueryVariables>({
  query: GET_RECOMMENDATIONS,
  variables: computed(() => ({
    factFinderChannel: fischer.factFinderChannel(),
    productIds: props.productIds,
  })),
  pause: computed(() => !props.productIds?.length),
  requestPolicy: 'network-only',
});

watch(data, (d) => {
  const value = d?.getRecommendations;
  if (value) {
    recommendedProducts.value =
      value.hits?.map((h: any) => h?.variantValues?.[0]?.id)?.join('|') ?? null;
  }
});

watch(
  () => props.productIds,
  (value) => {
    if (!value?.length) {
      recommendedProducts.value = null;
    }
  },
);
</script>

<style scoped src="./cross-selling-product-teasers-fi" />
